import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { MenuItem, Select } from 'seagull';
import { useIoContext } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import styles from './TimeSelector.module.scss';
import { getAvailableTimeSlots, getCurrentTimeSlot } from './TimeSelector.utils';
const defaultHelperText = (now, tzAbbreviation)=>"based on your timezone (".concat(tzAbbreviation || 'UTC', ")");
export default function TimeSelector(param) {
    let { onTimeChange, testId, currentDate } = param;
    const { t: texts } = useLocaleKeys('components.timeSelector');
    const { getNow, getTimezoneAbbreviation } = useIoContext();
    const [selectedTime, setSelectedTime] = useState(getCurrentTimeSlot(currentDate, getNow()).dateTimeValue);
    const [availableSlots, setAvailableSlots] = useState(getAvailableTimeSlots(currentDate, getNow()));
    const helperText = defaultHelperText(getNow(), getTimezoneAbbreviation(getNow()));
    useEffect(()=>{
        setAvailableSlots(getAvailableTimeSlots(currentDate, getNow()));
        const time = getCurrentTimeSlot(currentDate, getNow()).dateTimeValue;
        setSelectedTime(time);
        onTimeChange(time);
    }, [
        currentDate,
        onTimeChange
    ]);
    const handleChange = (event)=>{
        const newValue = event.target.value;
        setSelectedTime(newValue);
        onTimeChange(newValue);
    };
    return /*#__PURE__*/ _jsx(Select, {
        collapseHelperText: false,
        label: texts.label(),
        width: 287,
        testId: testId,
        value: selectedTime,
        onChange: handleChange,
        helperText: helperText,
        SelectProps: {
            autoWidth: true,
            MenuProps: {}
        },
        children: availableSlots.map((param)=>{
            let { dateTimeValue: value, timeLabel: label, slotTestId: testPrefix } = param;
            return /*#__PURE__*/ _jsx(MenuItem, {
                className: styles.menuItem,
                value: value,
                testId: "".concat(testId, "-").concat(testPrefix),
                children: label
            }, value);
        })
    });
}
